import React, { useEffect, useState } from "react";
import { Button, FormGroup, Input } from "reactstrap";

import { isEmail } from "../../modules/helper";

function SignInWithEmail({ sendOTP, email }) {
  const [state, setState] = useState({
    isValid: false,
    email: email,
  });

  const onSubmit = () => {
    if (state.isValid) {
      sendOTP(state.email, "email");
    }
  };

  function regexHandler(e) {
    const { value } = e.target;
    setState((prev) => ({ ...prev, email: value }));

    if (isEmail(value)) {
      setState((prev) => ({
        ...prev,
        isValid: true,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        isValid: false,
      }));
    }
  }

  useEffect(() => {
    email
      ? setState((prev) => ({
          ...prev,
          isValid: true,
        }))
      : setState((prev) => ({
          ...prev,
          isValid: false,
        }));
  }, []);

  function signInWithPressingEnterKey(e) {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      onSubmit();
    }
  }

  return (
    <>
      <div className="email-login-input">
        <FormGroup>
          <Input
            type="email"
            placeholder={"YourEmail@example.com"}
            value={state.email}
            onChange={regexHandler}
            onKeyDown={signInWithPressingEnterKey}
          />
        </FormGroup>
      </div>
      <div
        className={`verification-button ${
          state.isValid ? "activatedParentShadow" : "disabledParentShadow"
        } `}
      >
        <Button
          className={`${state.isValid ? "activatedButton" : "disabledButton"}`}
          disabled={state.isValid === true ? false : true}
          active
          block
          color="light"
          size=""
          onClick={onSubmit}
        >
          ارسال کد تایید
        </Button>
      </div>
    </>
  );
}

export default SignInWithEmail;
